import { Square } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

type WalletCompositionItem = {
  color?: string;
  _key: string;
  value: string | number;
  showPercent?: boolean;
};

export function CompositionItem({
  color,
  _key,
  value,
  showPercent = false,
}: WalletCompositionItem) {
  return (
    <Box
      sx={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        fontSize: '10px',
      }}>
      <Square
        htmlColor={color ? color : '#FF8211'}
        sx={{ fontSize: 12, mr: 0.5, verticalAlign: 'middle' }}
      />
      <Typography
        variant="body1"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          fontSize: 9,
          alignItems: 'center',
        }}>
        {_key} {showPercent ? value : ''}
      </Typography>
    </Box>
  );
}
